// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* started Checker page design */
.checker-container-dem {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between; /* it will give space between header and footer */
  background-color: #eaeaeb; /*page background color*/
}

.content-checker{
  flex: 1 1;
  padding-bottom: 20px; /* Adjust as needed to leave space for the footer */
}


  .contentchecker {
  display: flex;
  flex-direction: column;
  margin-left: 120px; /*PUSHING THE CARDS/*
  align-items: center;
  justify-content: flex-start; /* Adjust this to 'center' if you want content centered vertically */
  min-height: 10vh; /* Ensures the container takes at least the full viewport height */
  
}
.container {
  /* background-color: #eaeaeb; */
  padding: 0px;
  border-radius: 10px;

}

 


.card-margin {
  margin: 10px 0; /* Ensure there is some margin between cards */
}

.equal-height-ch {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 80%; /* same size of between cards */
}

.card-body.equal-height-body {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.card .card-header.no-border {
  border: 0;
}

/* .card-header:first-child {
  border-radius: calc(8px - 1px) calc(8px - 1px) 0 0;
} */


.card .card-header .custom-header {
  background: none;
  padding: 0 3.9375rem;
  font-weight: 400;
  display: flex;
  align-items: center;
  min-height: 50px;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  }  
/* started Checker page design */`, "",{"version":3,"sources":["webpack://./src/assets/css/DEMchecker.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B,EAAE,iDAAiD;EACjF,yBAAyB,EAAE,wBAAwB;AACrD;;AAEA;EACE,SAAO;EACP,oBAAoB,EAAE,mDAAmD;AAC3E;;;EAGE;EACA,aAAa;EACb,sBAAsB;EACtB,kBAAkB,EAAE;;mGAE6E;EACjG,gBAAgB,EAAE,kEAAkE;;AAEtF;AACA;EACE,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;;AAErB;;;;;AAKA;EACE,cAAc,EAAE,8CAA8C;AAChE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW,EAAE,+BAA+B;AAC9C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;;GAEG;;;AAGH;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB;AACF,gCAAgC","sourcesContent":["/* started Checker page design */\r\n.checker-container-dem {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n  justify-content: space-between; /* it will give space between header and footer */\r\n  background-color: #eaeaeb; /*page background color*/\r\n}\r\n\r\n.content-checker{\r\n  flex: 1;\r\n  padding-bottom: 20px; /* Adjust as needed to leave space for the footer */\r\n}\r\n\r\n\r\n  .contentchecker {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-left: 120px; /*PUSHING THE CARDS/*\r\n  align-items: center;\r\n  justify-content: flex-start; /* Adjust this to 'center' if you want content centered vertically */\r\n  min-height: 10vh; /* Ensures the container takes at least the full viewport height */\r\n  \r\n}\r\n.container {\r\n  /* background-color: #eaeaeb; */\r\n  padding: 0px;\r\n  border-radius: 10px;\r\n\r\n}\r\n\r\n \r\n\r\n\r\n.card-margin {\r\n  margin: 10px 0; /* Ensure there is some margin between cards */\r\n}\r\n\r\n.equal-height-ch {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  height: 80%; /* same size of between cards */\r\n}\r\n\r\n.card-body.equal-height-body {\r\n  flex-grow: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n}\r\n\r\n.card .card-header.no-border {\r\n  border: 0;\r\n}\r\n\r\n/* .card-header:first-child {\r\n  border-radius: calc(8px - 1px) calc(8px - 1px) 0 0;\r\n} */\r\n\r\n\r\n.card .card-header .custom-header {\r\n  background: none;\r\n  padding: 0 3.9375rem;\r\n  font-weight: 400;\r\n  display: flex;\r\n  align-items: center;\r\n  min-height: 50px;\r\n}\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  }  \r\n/* started Checker page design */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
